import React from 'react';
import { Feature, InjectorService, ToolbarService } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IAnimEntrFeature } from './anim-entr-interface';
import { config } from './config';
import { IEditorAnimPreviewManager } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/editor-state-animation/editor-anim-preview-manager.interface';
import AnimCommonTabPanel from '@src/framework/frame-pc/components/anim-common-tab-panel';
import {
    ENTR_LIST,
    PresetClassTypes,
} from '@src/slide/domain/ui-model/element-modeles/property/animation/constants';
import i18n from '@i18next/i18n';
import { ifElementSupportAnim } from '@src/slide/domain/ui-model/element-modeles/property/attachment/utils/attachment';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { isPreviewOnly } from '@src/page/toc/common/check-client-vars';
import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';

@Feature()
export class AnimEntrFeature extends BaseToolbarFeature implements IAnimEntrFeature {
    public id = config.id;
    public config = config;
    private toolbarService = InjectorService.get(ToolbarService);
    public constructor() {
        super();
    }

    public getContent() {
        return (
            <AnimCommonTabPanel
                getAnimationEditorService={this.getAnimationEditorService}
                selectedAnimManager={this.getSelectedAnimManager()}
                selectionService={this.getSelectionService()}
                editorAnimPreviewManager={this.getEditorAnimPreviewManager()}
                presetClass={PresetClassTypes.ENTR}
                animCategoryList={ENTR_LIST}
                title={i18n.t('进入')}
                num={5}
                showArrow={true}
                forceUpdateToolbarService={this.forceUpdateToolbarService}
            />
        );
    }

    public shouldDisabled(): boolean {
        if (isPreviewOnly() || this.isHistoryShown()
            || this.getUserPriviledgeService().pptEditorState !== PPTEditorStateEnumType.EDITABLE) return true;
        const selectedElementList = this.getSelectionService()?.selectedElements?.selectedArray;
        if (selectedElementList?.length === 1 && !ifElementSupportAnim(selectedElementList[0] as IShapeModel)) {
            return true;
        }
        const selectedAnimList = this.getSelectedAnimManager()?.selectedArray;
        return !selectedElementList?.length && !selectedAnimList?.length;
    }

    private forceUpdateToolbarService = () => {
        this.toolbarService.$forceUpdate();
    };

    private getEditorAnimPreviewManager(): IEditorAnimPreviewManager | undefined {
        return this.getAppService().viewableServiceLayer?.getEditorAnimPreviewManager();
    }

    private getAnimationEditorService = () => this.getAppService().editableServiceLayer?.animationEditorService;

    private isHistoryShown() {
        return this.getAppService().editableServiceLayer?.historyManager.isShown();
    }
}
